import styled, {css} from 'styled-components';

const rowContainer = css`
    display: flex !important;
    flex-direction: row !important;
`;

export const Container = styled.div`
    padding: 10px 10px;
    border-bottom: 1px solid #000;
    align-items: center;
    justify-content: space-between;
    ${props => props.isMobile ? `
        padding: 0px;
        margin: 0px;
    ` : rowContainer}
`;

export const InputBox = styled.input`
    margin-left: 20px;
    padding: 5px 20px;
    border: 1px solid #000;
    font-size: 25px;
`;

export const ButtonGroup = styled.div`
    align-items: center;
    ${props => props.isMobile ? `
        display: flex !important;
        flex-direction: column !important;
        align-items: center;
    ` : `
        justify-content: space-between;
        ${rowContainer}
    `}
`;

export const TapButton = styled.a`
    cursor: pointer;
    padding: 10px 16px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: #2c3c4e;
    text-decoration: none;
    :hover {
        color: #2c3c4e;
    }
`;

export const HomeButton = styled.button`
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    padding: 0 0 0 0;
    height: 48px;
    ${props => props.isMobile ? `
        width: 100%;
    `: `
        margin-left: 24px;
        margin-right: 24px;
    `}
`;

export const DropdownResult = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', 'Rambla', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 13px 8px;
`;

export const DropdownContainer = styled.div`
    z-index: 1;
    border: solid 0.5px #979797;
    position: absolute;
    background-color: #FFFFFF;
    width: 380px;
    border-style: solid;
`;

export const Timer = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 20px;
    background: rgb(0, 64, 133);
    color: rgb(255, 255, 255);
    width: 85px;
    ${props => props.isMobile ? `text-align: center; display: flex; flex-direction: column; justify-content: center;` : 
    `
        padding: 20px;
        position: absolute;
        right: 0px;
    `}
`